import { useState } from 'react';
import { Scale } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ModeProvider } from '@/providers/ModeProvider';
import DisputeTypesPage from '@/pages/settings/dispute-types';

export function Step6DisputeTypes() {
  const [setupNow, setSetupNow] = useState(false);

  return (
    <div className="flex flex-col h-full">
      {/* Step header */}
      <div className="mb-6 shrink-0">
        <h2 className="text-xl font-semibold mb-1">Dispute Types</h2>
        <p className="text-sm text-muted-foreground">
          Define the categories used to classify customer disputes.
        </p>
      </div>

      {/* Content */}
      <div className="flex-1 min-h-0 overflow-y-auto">
        {setupNow ? (
          <ModeProvider>
            <DisputeTypesPage />
          </ModeProvider>
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-primary/10 text-primary mb-6">
              <Scale className="h-10 w-10" />
            </div>
            <h3 className="text-lg font-semibold mb-2">No dispute types set up yet</h3>
            <p className="text-sm text-muted-foreground mb-6 max-w-sm">
              Dispute types are <strong>not mandatory</strong> — you can set up the rest of Access
              Collect without them. When you're ready, they can also be configured from{' '}
              <strong>Settings → Dispute Types</strong>.
            </p>
            <Button onClick={() => setSetupNow(true)} className="gap-2">
              <Scale className="h-4 w-4" />
              Set Up Dispute Types Now
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
